export var HowToRoutes;
(function (HowToRoutes) {
    HowToRoutes["HowTo"] = "how-to";
})(HowToRoutes || (HowToRoutes = {}));
